import React from 'react';
import { twMerge } from 'tailwind-merge';
import '@fontsource/inter/latin.css';
import '@fontsource/calistoga/latin-400.css';

const Layout = ({ children }: { children: React.ReactNode }) => {
  return (
    <>
      <meta name='viewport' content='width=device-width, initial-scale=1' />
      <style>
        {`
            :root {
              --font-sans: 'Inter', system-ui, -apple-system, sans-serif;
              --font-serif: 'Calistoga', serif;
            }
            body {
              font-family: var(--font-sans);
              margin: 0;
              padding: 0;
            }
            html {
              background-color: #111827; /* Ensures full page coverage */
            }
          `}
      </style>

      <div
        className={twMerge(
          'min-h-screen bg-gray-900 text-white antialiased font-sans'
        )}
      >
        {children}
      </div>
    </>
  );
};

export default Layout;
